const {angular} = window as any;

/**
 * The common module is a leaf module that contains constants/values/services/factories that are used
 * across all other modules.
 */
angular.module('GorillaBoy.common', []);


/**
 * The build module contains only one Constant which is a Map of internationalized strings
 */
angular.module('GorillaBoy.build', []);


angular.module('GorillaBoy.services', []);
angular.module('GorillaBoy.directives', ['GorillaBoy.services']);
angular.module('GorillaBoy.filters', []);
angular.module('GorillaBoy.ClientMetrics', ['GorillaBoy.common']);
angular.module('GorillaBoy.FeatureManager', []);
angular.module('GorillaBoy.Approvals', ['GorillaBoy.common', 'GorillaBoy.FeatureManager', 'ngRoute']);
angular.module('GorillaBoy.Tasks', ['GorillaBoy.common', 'GorillaBoy.FeatureManager', 'ngRoute']);
angular.module('GorillaBoy.Dboard', ['GorillaBoy.common', 'GorillaBoy.FeatureManager', 'ngRoute']);
angular.module('GorillaBoy.Tutorial', ['GorillaBoy.common', 'GorillaBoy.FeatureManager']);
angular.module('GorillaBoy.FileBrowser', ['ngRoute', 'ui.bootstrap', 'GorillaBoy.services', 'GorillaBoy.FeatureManager']);
angular.module('GorillaBoy.DocumentViewer', ['ui.bootstrap', 'GorillaBoy.services']);
angular.module('GorillaBoy.shareModal', []);
angular.module('GorillaBoy.Profile', []);
angular.module('GorillaBoy.Strings', []);
angular.module('GorillaBoy.Admin', ['ngRoute']);
angular.module('GorillaBoy.AdminWD', []);
angular.module('GorillaBoy.Analytics', []);
angular.module('GorillaBoy.OfficeEditor', ['GorillaBoy.services']);
angular.module('GorillaBoy.Dashboard', []);
angular.module('GorillaBoy.Search', []);
angular.module('GorillaBoy.Login', ['GorillaBoy.common']);

angular.module('GorillaBoy', [
        'ngRoute',
        'ngSanitize',
        'ngAnimate',
        'ui.bootstrap',
        'ui.bootstrap.popover',
        'ui.date',
        'ui.select',
        'GorillaBoy.build',
        'GorillaBoy.common',
        'GorillaBoy.directives',
        'GorillaBoy.filters',
        'GorillaBoy.services',
        'GorillaBoy.ClientMetrics',
        'GorillaBoy.FeatureManager',
        'GorillaBoy.FileBrowser',
        'GorillaBoy.Tasks',
        'GorillaBoy.Approvals',
        'GorillaBoy.Dboard',
        'GorillaBoy.DocumentViewer',
        'GorillaBoy.shareModal',
        'GorillaBoy.Profile',
        'GorillaBoy.Strings',
        'GorillaBoy.Tutorial',
        'GorillaBoy.Admin',
        'GorillaBoy.AdminWD',
        'GorillaBoy.Analytics',
        'GorillaBoy.OfficeEditor',
        'GorillaBoy.Dashboard',
        'GorillaBoy.Search',
        'GorillaBoy.Login',
        'pasvaz.bindonce',
        'pascalprecht.translate',
        'LocalStorageModule',
        'ngWebSocket',
        'asideModule',
        'search.QueryParser',
        'angularjs-dropdown-multiselect'
    ]);
